import React, {Component} from 'react';
import translate from '../../../utils/translations';
import edap from '@homeaway/edap-wrapper';
import PropTypes from 'prop-types';
import {ButtonPrimary} from '@homeaway/react-buttons';

import './PropertyReview.less';
import {Link} from '@homeaway/react-localization-components';

export class PropertyReview extends Component {
    static propTypes = {
        checkoutDate: PropTypes.string,
        reservationId: PropTypes.string,
        reviewFormUrl: PropTypes.string.isRequired,
        seenEvent: PropTypes.bool,
        translations: PropTypes.shape({}),
    };

    static defaultProps = {
        seenEvent: false,
        translations: {},
    };

    componentDidMount() {
        let {seenEvent} = this.props;

        if (seenEvent === true) {
            this.componentLoadedHandler();
        }
    }

    componentLoadedHandler = () => {
        let {checkoutDate, reservationId} = this.props;

        edap().push({
            name: 'generic.event',
            data: {
                eventaction: 'leave a review view',
                eventcategory: 'traveler activity',
                eventlabel: reservationId,
                eventvalue: checkoutDate,
            },
        });
    };

    submitReviewHandler = () => {
        let {checkoutDate, reservationId} = this.props;

        edap().push({
            name: 'generic.click',
            data: {
                eventaction: 'leave a review',
                eventcategory: 'traveler activity',
                eventlabel: reservationId,
                eventvalue: checkoutDate,
            },
        });
    };

    render() {
        let {translations} = this.props;

        return (
            <div className="PropertyReview rounded-border conversation-sidebar-section">
                <div>
                    <h3>
                        {translate(
                            translations,
                            'trav-dash/trav-home',
                            'messages',
                            'th.inbox.conversation.review.title'
                        )}
                    </h3>
                    <div>
                        {translate(
                            translations,
                            'trav-dash/trav-home',
                            'messages',
                            'th.inbox.conversation.review.body'
                        )}
                    </div>
                </div>
                <Link href={this.props.reviewFormUrl}>
                    {(localizedUrl) => (
                        <ButtonPrimary
                            className={'PropertyReview__button'}
                            href={localizedUrl}
                            label={translate(
                                translations,
                                'trav-dash/trav-home',
                                'messages',
                                'th.inbox.conversation.review.button'
                            )}
                            onClick={this.submitReviewHandler}
                            target="_blank"
                        />
                    )}
                </Link>
            </div>
        );
    }
}
